module.exports = __webpack_public_path__ + "fonts/SFUIText-SemiboldItalic.db98f5c0.woff";